import PresetSelector from '@/components/datagrid/PresetSelector';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Badge,
  Box,
  Button,
  Grow,
  InputAdornment,
  Tooltip,
} from '@mui/material';

const SubscriptionDataGridToolbar = ({ onSubscriptionCreate, ...props }) => {
  const [showToolbar, setShowToolbar] = useState(false);
  const navigate = useNavigate();
  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              backgroundColor: (theme) => theme.palette.background.paper,
              borderRadius: 2,
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="outlined"
          InputProps={{
            placeholder: 'Søg subscriptions...',
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          startIcon={<HomeWorkRoundedIcon />}
          endIcon={<ArrowForwardRoundedIcon />}
          variant="outlined"
          onClick={() => navigate('/PVO/buildings')}
          sx={{
            mx: 1,
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            textTransform: 'none',
            p: 0.9,
            mt: -0.5,
            color: 'text.primary',
            ':hover': {
              borderColor: 'divider',
            },
          }}
        >
          Gå til bygninger
        </Button>
        <PresetSelector {...props} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <>
          <Grow in={showToolbar}>
            <GridToolbar />
          </Grow>

          <Tooltip
            title={showToolbar ? 'Hide Options' : 'Show Options'}
            placement="top"
          >
            <Badge
              color="primary"
              badgeContent={props.filterModel?.items?.length || 0}
              invisible={!(props.filterModel?.items?.length > 0)} // hide badge when no filters
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              slotProps={{
                badge: {
                  sx: {
                    // Pull the badge INSIDE the button so it won't be clipped
                    top: -7,
                    right: -7,
                    transform: 'none', // cancel default translate(50%, -50%)
                    zIndex: 1,
                  },
                },
              }}
            >
              <Button
                startIcon={
                  showToolbar ? <FilterListOffIcon /> : <FilterListIcon />
                }
                variant="outlined"
                size="small"
                onClick={() => setShowToolbar(!showToolbar)}
                sx={{
                  borderRadius: 2,
                  borderColor: 'divider',
                  backgroundColor: 'background.paper',
                  textTransform: 'none',
                  p: 0.9,
                  mt: -0.5,
                  color: 'text.primary',
                }}
              >
                {showToolbar ? 'Skjul indstillinger' : 'Vis indstillinger'}
              </Button>
            </Badge>
          </Tooltip>
        </>

        {/* <IconButton onClick={onEditBillingMeters} sx={{ borderRadius: 1 }}>
          <Badge badgeContent={building.BillingMeters.length} color="primary">
            <SpeedRoundedIcon />
          </Badge>
        </IconButton>

        <IconButton onClick={onViewHealthChecks} sx={{ borderRadius: 1 }}>
          <Badge badgeContent={worstStateIcon} dot={false}>
            <i className="fa-solid fa-heart-pulse"></i>
          </Badge>
        </IconButton> */}
        <Button
          startIcon={<AddRoundedIcon />}
          variant="contained"
          onClick={onSubscriptionCreate}
          sx={{ mt: -0.5 }}
        >
          Ny subscription
        </Button>
      </Box>
    </GridToolbarContainer>
  );
};

export default SubscriptionDataGridToolbar;
